<template>
  <v-container
    id="towerServices"
    fluid
    tag="section"
  >
    <v-card
      flat
      class="mx-0 px-4 py-4"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              @click="getForms"
            >
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-row>
        <v-data-table
          :headers="headersForms"
          :items="forms"
          :items-per-page="50"
          fixed-header
          height="400"
          class="elevation-1"
        >
          <template v-slot:item._actions="{ item }">
            <v-menu
              bottom
              close-on-click
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Actions
                </v-btn>

              </template>
              <v-list>
                <v-list-item
                  v-if="item.publish_url && item.publish_url.length > 0"
                  link
                >
                  <v-list-item-title
                    @click="doOpenCognitoPreview(item)"
                  >
                    Cognito Preview
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.admin_url && item.admin_url.length > 0"
                  link
                >
                  <v-list-item-title
                    @click="doOpenCognitoAdmin(item)"
                  >
                    Cognito Admin
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-row>

    </v-card>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import {
    FORM_GET_FORMS, _COMMIT_LOG,
  } from '../../../store/actions.types'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'TowersHome',
    components: {
      // powAccessPointForm: () => import('@/components/pow/AccessPointForm'),
    },
    mixins: [basicMixin],
    data () {
      return {
        page: 1,
        filter: {},
        headersForms: [
          {
            text: 'Rowkey',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'rowkey',
          },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'display_text',
          },
          {
            text: 'Status',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'status',
          },
          {
            text: 'Source',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'source',
          },
          {
            text: 'Required',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'is_required',
          },
          {
            text: 'Notes',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'notes',
          },
          {
            text: 'Submissions',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'submissions',
          },
          {
            text: 'Action',
            align: 'start',
            sortable: false,
            groupable: false,
            value: '_actions',
          },
        ],
        itemsPerPageArray: [50, 100, 250, 500, 1000],
      }
    },
    computed: {
      ...mapGetters(['forms']),
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      // if (this.$route.params.account) {
      //   this.selectedAccount = this.$route.params.account
      // } else if (this.$route.params.key) {
      //   const payload = {
      //     key: this.$route.params.key,
      //     params: this.$route.query,
      //   }
      //   this.selectedAccount = await this.getAccount(payload)
      // }
      if (!this.forms || this.forms.length === 0) {
        await this.getForms()
      }
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getForms: FORM_GET_FORMS,
      }),
      async doOpenCognitoPreview (item) {
        this.commitLog({ message: 'Opening Cognito preview from external URL', item })
        // const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        // this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `${item.publish_url}`
        window.open(url, '_blank')
      },
      async doOpenCognitoAdmin (item) {
        this.commitLog({ message: 'Opening Cognito ADMIN from external URL', item })
        // const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        // this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `${item.admin_url}`
        window.open(url, '_blank')
      },
    },
  }
</script>
